import React from 'react';
import { UniversalCalculator } from './UniversalCalculator';
import { swpUniversalConfig } from './universalCalculatorConfigs';

export const SWPCalculator: React.FC = () => {
  return <UniversalCalculator config={swpUniversalConfig} />;
};
